import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function LegalModal({ title, effectiveDate, sections, onClose }) {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-background/80 backdrop-blur-xl"
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 10 }}
          transition={{ duration: 0.2 }}
          onClick={(e) => e.stopPropagation()}
          className="relative w-full max-w-3xl max-h-[85vh] bg-card border border-border rounded-2xl shadow-2xl flex flex-col"
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-lg border border-border/50 text-muted-foreground hover:text-primary hover:border-primary/50 transition-all"
          >
            <X className="w-4 h-4" />
          </button>

          <div className="p-8 pb-4 border-b border-border/30">
            <h2 className="font-inter font-bold text-2xl tracking-tight text-foreground uppercase">{title}</h2>
            <p className="text-xs text-muted-foreground font-inter tracking-wider mt-2">{effectiveDate}</p>
          </div>

          <div className="overflow-y-auto p-8 space-y-6">
            {sections.map((section, i) => (
              <div key={i}>
                <h3 className="text-sm font-inter font-bold tracking-wider uppercase text-primary mb-2">
                  {section.heading}
                </h3>
                <p className="text-sm text-muted-foreground font-inter leading-relaxed whitespace-pre-line">
                  {section.body}
                </p>
              </div>
            ))}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}